/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [calendar] = useParameter<number[]>("@calendar");
  const [commodities] = useParameter<number>("@commodities");
  const [commoditiesDisplay] = useParameter<number>("@commodities_display");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@calendar": calendar,
        "@commodities": commodities,
        "@commodities_display": commoditiesDisplay,
      }
    });
  }, [title, subtitle, title, subtitle, exportBuilder, calendar, commodities, commoditiesDisplay]);
}

